export const Status = {
  draft_by_lender: 'draft_by_lender',
  draft: 'draft',
  approved1_c: 'approved1_c',
  rejected1_c: 'rejected1_c',
  rejected2_c: 'rejected2_c',
  returning_c: 'returning_c',
  returned_c: 'returned_c',
  applied_c: 'applied_c',
  withdrawn_c: 'listing_cancelled',
  withdrawn_c2: 'withdrawn_c',
  shipped_c: 'shipped_c',
  claimed_c: 'claimed_c',
  claiming_c: 'claiming_c',
  deleted: 'deleted',
  cancel_listing: 'cancel_listing',
  returning_with_complaint: 'returning_with_complaint_r',
  returning_r: 'returning_r',
  rented: 'rented',
  listed: 'listed',
  rental_delivered: 'rental_delivered_r',
  rental_delivered_1: 'rental_delivered',
  fit_returning_r: 'fit_returning_r',
  returning_late_r: 'returning_late_r',
  for_donation: 'for_donation',
  for_recycling: 'for_recycling',
  unsaved: 'unsaved',
  in_transit: 'in_transit',
  pending_approval: 'pending_approval',
  needs_repair: 'needs_repair',
  purchased: 'purchased',
  cancel_order: 'cancel_order',
};
